import path from 'node:path'
import * as p from '@clack/prompts'
import type { ListIntegrationsCommandOptions } from '@core-engine/commands/runtime.js'
import { resolveConfig } from '@next-adapter/config.js'
import { listAvailableIntegrations } from '@next-adapter/integration-runtime.js'

export async function runListIntegrationsCommand(
  options: ListIntegrationsCommandOptions
): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()
  const config = await resolveConfig(cwd)
  const installedIntegrations = new Set(config.integrations.installed)

  const lines = listAvailableIntegrations().map((integration) => {
    const status = installedIntegrations.has(integration.id) ? 'installed' : 'available'
    return `${integration.id.padEnd(10)} ${status.padEnd(10)} ${integration.kind.padEnd(8)} ${integration.description}`
  })

  p.note(lines.join('\n'), 'BetterStart integrations')
  p.outro(
    `${installedIntegrations.size} installed, ${lines.length - installedIntegrations.size} available`
  )
}
